/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AddConfigToBasketResult = Basket | ConfigNotFoundError;

export type Attribute = {
  __typename?: 'Attribute';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Basket = {
  __typename?: 'Basket';
  basketLines: Array<BasketLine>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BasketLine = {
  __typename?: 'BasketLine';
  /** Basket */
  basket: Basket;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Amount of variants */
  quantity: Scalars['Int']['output'];
  /** System Config */
  systemConfig: SystemConfig;
  /** Total cost of the basket line */
  totalCost: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** User who created the basket line */
  userId: Scalars['String']['output'];
};

export type BasketLineNotFoundError = {
  __typename?: 'BasketLineNotFoundError';
  message: Scalars['String']['output'];
};

export type BasketNotFoundError = {
  __typename?: 'BasketNotFoundError';
  message: Scalars['String']['output'];
};

export type CalculationError = {
  __typename?: 'CalculationError';
  configurationSourceKey: Scalars['String']['output'];
  filter?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ClearBasketMutationResult = Basket | BasketNotFoundError;

export type ConfigNotFoundError = {
  __typename?: 'ConfigNotFoundError';
  message: Scalars['String']['output'];
};

export type ConfigVariantLine = {
  __typename?: 'ConfigVariantLine';
  /** Key, signaling from which service this was inserted */
  configurationSourceKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Amount of variants */
  quantity: Scalars['Float']['output'];
  /** System Config */
  systemConfig: SystemConfig;
  updatedAt: Scalars['DateTime']['output'];
  /** Product Variant */
  variant: Variant;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export type CreateConfigVariantLineInput = {
  /** Key, representing the source of a grouping of products, EG: Zubehör */
  configurationSourceKey: Scalars['String']['input'];
  /** Amount of variants */
  quantity: Scalars['Int']['input'];
  /** System Config id */
  systemConfigId: Scalars['String']['input'];
  /** Product Variant id */
  variantId: Scalars['String']['input'];
};

export type CreateConfigVariantLineResult = ConfigVariantLine | VariantNotFoundError;

export type CreateSystemConfigResult = SystemConfig | SystemNotFoundError;

export type Customer = {
  __typename?: 'Customer';
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CustomerSpecificPrice = {
  __typename?: 'CustomerSpecificPrice';
  basePrice: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type DeleteSystemConfigResult = ConfigNotFoundError | SystemConfig;

export type ExpertCheckMessage = {
  __typename?: 'ExpertCheckMessage';
  authorCustomerId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExpertCheckStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Finished = 'FINISHED',
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED'
}

export type FieldHideCondition = {
  __typename?: 'FieldHideCondition';
  /** Condition Logic */
  condition?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Disable if Hidden */
  disableIfHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Path to the module and field (moduleName.fieldName) */
  field: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Operator */
  operator: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  frontendFullPath?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['Int']['output']>;
};

export type InputModuleFieldValue = {
  fieldId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ModuleFieldValue = {
  __typename?: 'ModuleFieldValue';
  /** System Module Field code */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** System Module Field id */
  fieldId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** System Module code */
  moduleCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Value of the field */
  value: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeExpertCheck: UpdateSystemConfigResult;
  addConfigToBasket: AddConfigToBasketResult;
  clearBasket: ClearBasketMutationResult;
  createConfigVariantLine: CreateConfigVariantLineResult;
  createSystemConfig: CreateSystemConfigResult;
  deleteSystemConfig: DeleteSystemConfigResult;
  finishExpertCheck: UpdateSystemConfigResult;
  removeBasketLine: RemoveBasketLineResult;
  removeConfigVariantLine: RemoveConfigVariantLineResult;
  requestExpertCheck: UpdateSystemConfigResult;
  sendBasketToOrder: SendBasketToOrderMutationResult;
  updateBasketLine: BasketLine;
  updateConfigVariantLine: UpdateConfigVariantLineResult;
  updateSystemConfig: UpdateSystemConfigResult;
};


export type MutationAcknowledgeExpertCheckArgs = {
  systemConfigId: Scalars['String']['input'];
};


export type MutationAddConfigToBasketArgs = {
  configId: Scalars['String']['input'];
};


export type MutationCreateConfigVariantLineArgs = {
  createConfigVariantLineInput: CreateConfigVariantLineInput;
};


export type MutationCreateSystemConfigArgs = {
  systemId: Scalars['String']['input'];
};


export type MutationDeleteSystemConfigArgs = {
  systemConfigId: Scalars['String']['input'];
};


export type MutationFinishExpertCheckArgs = {
  message: Scalars['String']['input'];
  systemConfigId: Scalars['String']['input'];
};


export type MutationRemoveBasketLineArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveConfigVariantLineArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestExpertCheckArgs = {
  message: Scalars['String']['input'];
  systemConfigId: Scalars['String']['input'];
};


export type MutationSendBasketToOrderArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateBasketLineArgs = {
  updateBasketLineInput: UpdateBasketLineInput;
};


export type MutationUpdateConfigVariantLineArgs = {
  updateConfigVariantLineInput: UpdateConfigVariantLineInput;
};


export type MutationUpdateSystemConfigArgs = {
  config: UpdateSystemConfigInput;
};

export type Query = {
  __typename?: 'Query';
  accessories: Array<Variant>;
  activeBasket?: Maybe<Basket>;
  activeCustomer?: Maybe<Customer>;
  basket?: Maybe<Basket>;
  baskets?: Maybe<Array<Basket>>;
  contactPerson?: Maybe<ContactPerson>;
  isAdmin: Scalars['Boolean']['output'];
  requestedExpertChecks: Array<SystemConfig>;
  system: System;
  systemConfig?: Maybe<SystemConfig>;
  systemConfigs: Array<SystemConfig>;
  systems: Array<System>;
};


export type QueryAccessoriesArgs = {
  filter: Scalars['JSONObject']['input'];
  systemId: Scalars['String']['input'];
};


export type QueryBasketArgs = {
  id: Scalars['String']['input'];
};


export type QueryIsAdminArgs = {
  companyId: Scalars['String']['input'];
};


export type QuerySystemArgs = {
  id: Scalars['String']['input'];
};


export type QuerySystemConfigArgs = {
  systemConfigId: Scalars['String']['input'];
};


export type QuerySystemConfigsArgs = {
  limitToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveBasketLineResult = BasketLine | BasketLineNotFoundError;

export type RemoveConfigVariantLineResult = ConfigNotFoundError | ConfigVariantLine;

export type SendBasketToOrderMutationResult = BasketNotFoundError | SendBasketToOrderResult;

export type SendBasketToOrderResult = {
  __typename?: 'SendBasketToOrderResult';
  errors: Array<Scalars['String']['output']>;
};

export type System = {
  __typename?: 'System';
  /** Button text for the system */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Code of the system */
  code?: Maybe<Scalars['String']['output']>;
  /** Description of the system */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the system is enabled */
  enable?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the system */
  id: Scalars['String']['output'];
  /** Path of the system image the entry page shows on the tile */
  image?: Maybe<Scalars['String']['output']>;
  /** Connected system modules */
  modules: Array<SystemModule>;
  /** Name of the system */
  name?: Maybe<Scalars['String']['output']>;
  /** Subtitle for the system */
  subTitle?: Maybe<Scalars['String']['output']>;
  systemConfigs: SystemConfig;
  /** Ids of the Systemfinder filters on the product categories that link this system */
  systemFinderFilterIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type SystemConfig = {
  __typename?: 'SystemConfig';
  basketLines: Array<BasketLine>;
  /** Debug Information */
  calculationErrors: Array<CalculationError>;
  /** The code of the system source */
  code: Scalars['String']['output'];
  /** Company this Configuration is bound to */
  companyId: Scalars['String']['output'];
  configVariantLines: Array<ConfigVariantLine>;
  createdAt: Scalars['DateTime']['output'];
  /** Customer who created the Configuration */
  customerId: Scalars['String']['output'];
  expertCheckMessages: Array<ExpertCheckMessage>;
  /** Status of the expert check */
  expertCheckStatus: ExpertCheckStatus;
  id: Scalars['String']['output'];
  /** System Modules */
  moduleFieldValues: Array<ModuleFieldValue>;
  /** Name of the system config */
  name: Scalars['String']['output'];
  /** The system that is being configured, can be null if the system does not exist anymore */
  system?: Maybe<System>;
  /** The id of the system source */
  systemId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SystemModule = {
  __typename?: 'SystemModule';
  /** Identification code */
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Connected module fields */
  fields?: Maybe<Array<SystemModuleField>>;
  id: Scalars['String']['output'];
  /** Name of the module */
  name: Scalars['String']['output'];
  /** Boolean to make the module optional */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** When true, the module is instantiated per ZUG based on the General Ausführung field */
  perZug?: Maybe<Scalars['Boolean']['output']>;
  /** Connected tooltip */
  tooltip?: Maybe<SystemTooltip>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SystemModuleField = {
  __typename?: 'SystemModuleField';
  /** Identifier of the module field */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Connected field options */
  hideConditions?: Maybe<Array<FieldHideCondition>>;
  id: Scalars['String']['output'];
  /** Name of the module field */
  name: Scalars['String']['output'];
  /** Field options as {key, value} pairs. Pimcore always emits the pair; for single-column tables `key === value`, for two-column tables `key` is the visible display label and `value` is the submit/lookup value (counter-intuitive naming kept to match the Pimcore table column order). */
  options?: Maybe<Array<SystemModuleFieldOption>>;
  /** Endpoint to get dynamic fields from, for debug reasons included, replace %code% with the value of the code */
  selectEndpoint?: Maybe<Scalars['String']['output']>;
  /** Connected tooltip */
  tooltip: SystemTooltip;
  /** Unit of measurement of the module field */
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Connected validation object */
  validation: SystemModuleFieldValidation;
  valueType: ValueType;
};

export type SystemModuleFieldOption = {
  __typename?: 'SystemModuleFieldOption';
  /** Display label of the option (Pimcore option table column 1) */
  key: Scalars['String']['output'];
  /** Submit/storage/lookup value (Pimcore option table column 2; for single-column tables this equals `key`) */
  value: Scalars['String']['output'];
};

export type SystemModuleFieldValidation = {
  __typename?: 'SystemModuleFieldValidation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Max allowed value for field */
  max?: Maybe<Scalars['String']['output']>;
  /** Min allowed value for field */
  min?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SystemNotFoundError = {
  __typename?: 'SystemNotFoundError';
  message: Scalars['String']['output'];
};

export type SystemTooltip = {
  __typename?: 'SystemTooltip';
  createdAt: Scalars['DateTime']['output'];
  /** Description of the tooltip */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Image url of the tooltip */
  image?: Maybe<Scalars['String']['output']>;
  /** Title of the tooltip */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TranslatedString = {
  __typename?: 'TranslatedString';
  de?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
};

export type UpdateBasketLineInput = {
  id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpdateConfigVariantLineInput = {
  id: Scalars['String']['input'];
  /** Amount of variants */
  quantity: Scalars['Int']['input'];
};

export type UpdateConfigVariantLineResult = ConfigNotFoundError | ConfigVariantLine;

export type UpdateSystemConfigInput = {
  /** If passed updates the ModuleFieldsValues */
  moduleFieldValues?: InputMaybe<Array<InputModuleFieldValue>>;
  /** If passed updates the name of the system config */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the system config to update */
  systemConfigId: Scalars['String']['input'];
};

export type UpdateSystemConfigResult = ConfigNotFoundError | SystemConfig | SystemNotFoundError;

/** Type of the module field */
export enum ValueType {
  Bool = 'BOOL',
  DynamicSelect = 'DYNAMIC_SELECT',
  Number = 'NUMBER',
  Select = 'SELECT'
}

export type Variant = {
  __typename?: 'Variant';
  absolutePath?: Maybe<TranslatedString>;
  configVariantLines: Array<ConfigVariantLine>;
  configuratorAttributes: Array<Attribute>;
  description?: Maybe<TranslatedString>;
  images?: Maybe<Array<Image>>;
  name?: Maybe<TranslatedString>;
  price?: Maybe<CustomerSpecificPrice>;
  sku?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<TranslatedString>;
  systemName?: Maybe<Scalars['String']['output']>;
  taxCategory?: Maybe<Scalars['String']['output']>;
  title?: Maybe<TranslatedString>;
  variantId: Scalars['String']['output'];
};

export type VariantNotFoundError = {
  __typename?: 'VariantNotFoundError';
  message: Scalars['String']['output'];
};

export type ConfigurationFragment = { __typename?: 'SystemConfig', id: string, name: string, expertCheckStatus: ExpertCheckStatus, moduleFieldValues: Array<{ __typename?: 'ModuleFieldValue', value: string, fieldId: string }>, configVariantLines: Array<{ __typename?: 'ConfigVariantLine', id: string, configurationSourceKey: string, quantity: number, variant: { __typename?: 'Variant', variantId: string, sku?: string | null, name?: { __typename?: 'TranslatedString', de?: string | null, en?: string | null } | null, images?: Array<{ __typename?: 'Image', fileName?: string | null, fileSize?: string | null, frontendFullPath?: string | null }> | null, price?: { __typename?: 'CustomerSpecificPrice', basePrice: number, price: number } | null } }> };

export type LanguageFragment = { __typename?: 'TranslatedString', de?: string | null, en?: string | null };

export type SystemFragment = { __typename?: 'System', id: string, name?: string | null, code?: string | null, subTitle?: string | null, modules: Array<{ __typename?: 'SystemModule', id: string, name: string, optional?: boolean | null, code?: string | null, perZug?: boolean | null, tooltip?: { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null } | null, fields?: Array<{ __typename?: 'SystemModuleField', id: string, name: string, valueType: ValueType, unit?: string | null, defaultValue?: string | null, code: string, validation: { __typename?: 'SystemModuleFieldValidation', min?: string | null, max?: string | null }, options?: Array<{ __typename?: 'SystemModuleFieldOption', key: string, value: string }> | null, hideConditions?: Array<{ __typename?: 'FieldHideCondition', field: string, operator: string, value: string, disableIfHidden?: boolean | null, condition?: string | null }> | null, tooltip: { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null } }> | null }> };

export type SystemTooltipFragment = { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null };

export type AcknowledgeExpertCheckMutationVariables = Exact<{
  systemConfigId: Scalars['String']['input'];
}>;


export type AcknowledgeExpertCheckMutation = { __typename?: 'Mutation', acknowledgeExpertCheck: { __typename: 'ConfigNotFoundError', message: string } | { __typename: 'SystemConfig', id: string, name: string, expertCheckStatus: ExpertCheckStatus } | { __typename: 'SystemNotFoundError', message: string } };

export type AddConfigToBasketMutationVariables = Exact<{
  configId: Scalars['String']['input'];
}>;


export type AddConfigToBasketMutation = { __typename?: 'Mutation', addConfigToBasket: { __typename: 'Basket', id: string } | { __typename: 'ConfigNotFoundError', message: string } };

export type ClearBasketMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearBasketMutation = { __typename?: 'Mutation', clearBasket: { __typename: 'Basket', id: string } | { __typename: 'BasketNotFoundError', message: string } };

export type CreateConfigVariantLineMutationVariables = Exact<{
  input: CreateConfigVariantLineInput;
}>;


export type CreateConfigVariantLineMutation = { __typename?: 'Mutation', createConfigVariantLine: { __typename: 'ConfigVariantLine' } | { __typename: 'VariantNotFoundError' } };

export type CreateSystemConfigMutationVariables = Exact<{
  systemId: Scalars['String']['input'];
}>;


export type CreateSystemConfigMutation = { __typename?: 'Mutation', createSystemConfig: { __typename: 'SystemConfig', id: string, name: string, code: string } | { __typename: 'SystemNotFoundError', message: string } };

export type DeleteSystemConfigMutationVariables = Exact<{
  systemConfigId: Scalars['String']['input'];
}>;


export type DeleteSystemConfigMutation = { __typename?: 'Mutation', deleteSystemConfig: { __typename: 'ConfigNotFoundError', message: string } | { __typename: 'SystemConfig', id: string, name: string } };

export type FinishExpertCheckMutationVariables = Exact<{
  systemConfigId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type FinishExpertCheckMutation = { __typename?: 'Mutation', finishExpertCheck: { __typename: 'ConfigNotFoundError', message: string } | { __typename: 'SystemConfig', id: string, name: string, expertCheckStatus: ExpertCheckStatus } | { __typename: 'SystemNotFoundError', message: string } };

export type RemoveBasketLineMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveBasketLineMutation = { __typename?: 'Mutation', removeBasketLine: { __typename?: 'BasketLine', id: string } | { __typename?: 'BasketLineNotFoundError', message: string } };

export type RemoveConfigVariantLineMutationVariables = Exact<{
  configVariantLineId: Scalars['String']['input'];
}>;


export type RemoveConfigVariantLineMutation = { __typename?: 'Mutation', removeConfigVariantLine: { __typename?: 'ConfigNotFoundError', message: string } | { __typename?: 'ConfigVariantLine', id: string } };

export type RequestExpertCheckMutationVariables = Exact<{
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type RequestExpertCheckMutation = { __typename?: 'Mutation', requestExpertCheck: { __typename: 'ConfigNotFoundError', message: string } | { __typename: 'SystemConfig', id: string, name: string } | { __typename: 'SystemNotFoundError', message: string } };

export type SendBasketToOrderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SendBasketToOrderMutation = { __typename?: 'Mutation', sendBasketToOrder: { __typename: 'BasketNotFoundError' } | { __typename: 'SendBasketToOrderResult' } };

export type UpdateBasketLineMutationVariables = Exact<{
  input: UpdateBasketLineInput;
}>;


export type UpdateBasketLineMutation = { __typename?: 'Mutation', updateBasketLine: { __typename?: 'BasketLine', id: string, quantity: number } };

export type UpdateConfigVariantLineMutationVariables = Exact<{
  configVariantLineId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type UpdateConfigVariantLineMutation = { __typename?: 'Mutation', updateConfigVariantLine: { __typename?: 'ConfigNotFoundError', message: string } | { __typename?: 'ConfigVariantLine', id: string, quantity: number, variant: { __typename?: 'Variant', variantId: string } } };

export type UpdateSystemConfigMutationVariables = Exact<{
  config: UpdateSystemConfigInput;
}>;


export type UpdateSystemConfigMutation = { __typename?: 'Mutation', updateSystemConfig: { __typename: 'ConfigNotFoundError', message: string } | { __typename: 'SystemConfig', id: string, name: string, expertCheckStatus: ExpertCheckStatus, system?: { __typename?: 'System', id: string, name?: string | null, code?: string | null, subTitle?: string | null, modules: Array<{ __typename?: 'SystemModule', id: string, name: string, optional?: boolean | null, code?: string | null, perZug?: boolean | null, tooltip?: { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null } | null, fields?: Array<{ __typename?: 'SystemModuleField', id: string, name: string, valueType: ValueType, unit?: string | null, defaultValue?: string | null, code: string, validation: { __typename?: 'SystemModuleFieldValidation', min?: string | null, max?: string | null }, options?: Array<{ __typename?: 'SystemModuleFieldOption', key: string, value: string }> | null, hideConditions?: Array<{ __typename?: 'FieldHideCondition', field: string, operator: string, value: string, disableIfHidden?: boolean | null, condition?: string | null }> | null, tooltip: { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null } }> | null }> } | null, calculationErrors: Array<{ __typename?: 'CalculationError', configurationSourceKey: string, type: string, message?: string | null, filter?: string | null }>, moduleFieldValues: Array<{ __typename?: 'ModuleFieldValue', value: string, fieldId: string }>, configVariantLines: Array<{ __typename?: 'ConfigVariantLine', id: string, configurationSourceKey: string, quantity: number, variant: { __typename?: 'Variant', variantId: string, sku?: string | null, name?: { __typename?: 'TranslatedString', de?: string | null, en?: string | null } | null, images?: Array<{ __typename?: 'Image', fileName?: string | null, fileSize?: string | null, frontendFullPath?: string | null }> | null, price?: { __typename?: 'CustomerSpecificPrice', basePrice: number, price: number } | null } }> } | { __typename: 'SystemNotFoundError', message: string } };

export type AccessoriesQueryVariables = Exact<{
  systemId: Scalars['String']['input'];
  filter: Scalars['JSONObject']['input'];
}>;


export type AccessoriesQuery = { __typename?: 'Query', accessories: Array<{ __typename?: 'Variant', variantId: string, sku?: string | null, systemName?: string | null, name?: { __typename?: 'TranslatedString', de?: string | null, en?: string | null } | null, slug?: { __typename?: 'TranslatedString', de?: string | null, en?: string | null } | null, absolutePath?: { __typename?: 'TranslatedString', de?: string | null, en?: string | null } | null, images?: Array<{ __typename?: 'Image', fileName?: string | null, fileSize?: string | null, frontendFullPath?: string | null }> | null, price?: { __typename?: 'CustomerSpecificPrice', basePrice: number, price: number } | null }> };

export type ActiveBasketQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveBasketQuery = { __typename?: 'Query', activeBasket?: { __typename?: 'Basket', id: string, basketLines: Array<{ __typename?: 'BasketLine', id: string, totalCost: number, quantity: number, systemConfig: { __typename?: 'SystemConfig', id: string, name: string }, basket: { __typename?: 'Basket', id: string, state: string } }> } | null };

export type ActiveCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCustomerQuery = { __typename?: 'Query', activeCustomer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string, emailAddress: string, title: string } | null };

export type ContactPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPersonQuery = { __typename?: 'Query', contactPerson?: { __typename?: 'ContactPerson', image?: string | null, name?: string | null, position?: string | null, phone?: string | null, mobile?: string | null, email?: string | null } | null };

export type IsAdminQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type IsAdminQuery = { __typename?: 'Query', isAdmin: boolean };

export type SystemConfigByIdQueryVariables = Exact<{
  systemConfigId: Scalars['String']['input'];
}>;


export type SystemConfigByIdQuery = { __typename?: 'Query', systemConfig?: { __typename?: 'SystemConfig', id: string, name: string, expertCheckStatus: ExpertCheckStatus, system?: { __typename?: 'System', id: string, name?: string | null, code?: string | null, subTitle?: string | null, modules: Array<{ __typename?: 'SystemModule', id: string, name: string, optional?: boolean | null, code?: string | null, perZug?: boolean | null, tooltip?: { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null } | null, fields?: Array<{ __typename?: 'SystemModuleField', id: string, name: string, valueType: ValueType, unit?: string | null, defaultValue?: string | null, code: string, validation: { __typename?: 'SystemModuleFieldValidation', min?: string | null, max?: string | null }, options?: Array<{ __typename?: 'SystemModuleFieldOption', key: string, value: string }> | null, hideConditions?: Array<{ __typename?: 'FieldHideCondition', field: string, operator: string, value: string, disableIfHidden?: boolean | null, condition?: string | null }> | null, tooltip: { __typename?: 'SystemTooltip', title?: string | null, description?: string | null, image?: string | null } }> | null }> } | null, moduleFieldValues: Array<{ __typename?: 'ModuleFieldValue', value: string, fieldId: string }>, configVariantLines: Array<{ __typename?: 'ConfigVariantLine', id: string, configurationSourceKey: string, quantity: number, variant: { __typename?: 'Variant', variantId: string, sku?: string | null, name?: { __typename?: 'TranslatedString', de?: string | null, en?: string | null } | null, images?: Array<{ __typename?: 'Image', fileName?: string | null, fileSize?: string | null, frontendFullPath?: string | null }> | null, price?: { __typename?: 'CustomerSpecificPrice', basePrice: number, price: number } | null } }> } | null };

export type SystemConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemConfigsQuery = { __typename?: 'Query', systemConfigs: Array<{ __typename?: 'SystemConfig', id: string, createdAt: any, name: string, code: string, expertCheckStatus: ExpertCheckStatus, companyId: string, customerId: string }> };

export type SystemsQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemsQuery = { __typename?: 'Query', systems: Array<{ __typename?: 'System', id: string, name?: string | null, code?: string | null, description?: string | null, enable?: boolean | null, buttonText?: string | null, subTitle?: string | null, modules: Array<{ __typename?: 'SystemModule', name: string }> }> };

export type SystemsForEntryPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemsForEntryPageQuery = { __typename?: 'Query', systems: Array<{ __typename?: 'System', id: string, name?: string | null, code?: string | null, buttonText?: string | null, enable?: boolean | null, systemFinderFilterIds?: Array<string> | null, image?: string | null }> };
